import { handleKeyDownNumeric, parseNumber } from '../../../../../helpers'

function formatNumber(value: string, digits?: number, maxDigits?: number): string {
    const rawValue = value.replace(/\s/g, '').replace(/^0+(?=\d)/, '')
    const separator = rawValue.includes(',') ? ',' : '.'
    const [integer, decimal = ''] = rawValue.split(/[,.]/)

    if (digits !== undefined) {
        let resultDecimal = decimal

        if (maxDigits !== undefined && decimal.length > maxDigits) {
            resultDecimal = decimal.slice(0, maxDigits)
        }

        if (resultDecimal.length < digits) {
            resultDecimal = (resultDecimal + '0'.repeat(digits)).slice(0, digits)
        }

        if (resultDecimal === '' && digits > 0) {
            resultDecimal = '0'.repeat(digits)
        }

        return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + separator + resultDecimal
    }

    const defaultDigits = maxDigits !== undefined ? Math.min(3, maxDigits) : 3
    const defaultDecimal = decimal.slice(0, defaultDigits)

    return (
        integer.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
        (defaultDecimal ? `${separator}${defaultDecimal}` : '')
    )
}

function roundDecimal(value: number, decimals: number): number {
    return Number(Math.round(Number(value + 'e' + decimals)) + 'e-' + decimals)
}

const formatVolume = (value: string) => {
    if (!value) {
        return
    }
    let cleaned = value?.replace(/[^\d\s.,]/g, '')
    cleaned = cleaned.replace(/\s+/g, ' ')

    let separatorFound = false
    cleaned = cleaned.replace(/[.,]/g, (match) => {
        if (!separatorFound) {
            separatorFound = true
            return match
        }
        return ''
    })

    if (cleaned[0] === '.' || cleaned[0] === ',') {
        cleaned = '0' + cleaned
    }
    if (cleaned[cleaned.length - 1] === '.' || cleaned[cleaned.length - 1] === ',') {
        return cleaned
    }

    return formatNumber(cleaned)
}

const checkIsRuble = (value: string): boolean => {
    return (
        value ===
            'Услуги по предоставлению доступа к Системе реестра (Открытие лицевого счета / Обслуживание лицевого счета)' ||
        value ===
            'Услуги, связанные с использованием функциональных возможностей Системы реестра (Регистрация ЗГО / Подтверждение статуса ЗГО)'
    )
}

export { formatNumber, handleKeyDownNumeric, parseNumber, roundDecimal, formatVolume, checkIsRuble }
